<div class="error">
  <div class="error-body">
    <h1 class="error-heading">Page Not Found</h1>
    <h4 class="error-subheading">We are sorry, the page you requested cannot be found.</h4>
    <p>
      <small>The URL may be misspelled or the page you're looking for is no longer available. If you think you have
        arrived here by our mistake, please <a href="#">contact us</a>.
      </small>
    </p>
    <p><a class="btn btn-primary btn-pill btn-thick" href="/">Return to homepage</a></p>
  </div>
  <div class="error-footer">
    <p>
      <small>©{{ currentYear }} ExxonMobil</small>
    </p>
  </div>
</div>